import { useState } from "react";
import { useParams } from "react-router-dom";

import ButtonV2 from "../../../../../src/components/ui/button/v2";
import StageWorkflowConfirmCaseProgressionModal from "../../../../../src/features/stageWorkflow/components/StageWorkflowConfirmCaseProgressionModal";

import { useAppDispatch, useAppSelector } from "../../../../../src/app/store";
import { useLoggedInUserId } from "../../../../../src/features/auth/logic/rbac";
import { selectParticipantByType } from "../../../../../src/features/caseinfo/logic/ParticipantsSlice";

import {
  CaseStageEnum,
  CaseStageAction,
} from "../../../../../src/api/caseStages";

import { ParticipantType } from "../../../../../src/api/participants";
import { selectCurrentCaseStage } from "../../../../../src/features/caseinfo/logic/Slice";
import { selectStageConfigByStage } from "../../../../../src/features/caseStages/logic/slice";

import { updateCaseStage } from "../../../../../src/features/caseStages/logic/thunks";
import { showErrorToast, showSuccessToast } from "../../../../../src/lib/toast";

export const IOSubmitIRStageButton: React.FC = () => {
  const { id: caseId } = useParams<{ id: string }>();

  const dispatch = useAppDispatch();
  const loggedInUserId = useLoggedInUserId();

  const currentStage = useAppSelector(selectCurrentCaseStage);

  const investigatorParticipant = useAppSelector((state) =>
    selectParticipantByType(state, ParticipantType.INVESTIGATOR)
  );

  const investigatorId = investigatorParticipant?.participant_id;

  const isInvestigatingOfficer = loggedInUserId === investigatorId;

  const stageConfig = useAppSelector(
    selectStageConfigByStage(CaseStageEnum.IO_SUBMIT_IR)
  );

  const submitActionConfig = stageConfig?.actions?.find(
  (a) => a.action === CaseStageAction.SUBMIT_INVESTIGATION_REPORT
  );

  const nextStage = submitActionConfig?.next_stage;

  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  if (
    !isInvestigatingOfficer ||
    currentStage?.stage !== CaseStageEnum.IO_SUBMIT_IR ||
    !nextStage
  ) {
    return null;
  }

  const handleConfirm = async (remarks?: string) => {
    if (!caseId || !nextStage) return;

    try {
      setIsLoading(true);

      const request = {
        stage: nextStage,
        source_action: CaseStageAction.SUBMIT_INVESTIGATION_REPORT,
        stage_data: {
          notes: remarks,
        },
      };

      await dispatch(updateCaseStage({ caseId, request })).unwrap();

      showSuccessToast("Investigation Report submitted successfully");

      setIsOpen(false);
    } catch (error) {
      showErrorToast("Failed to submit Investigation Report");
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <ButtonV2
        variant="primary"
        size="md"
        onClick={() => setIsOpen(true)}
        className="h-[36px] px-4 py-2 rounded-md shadow-[0px_1px_2px_rgba(0,0,0,0.05)]"
      >
        Submit
      </ButtonV2>

      <StageWorkflowConfirmCaseProgressionModal
        isOpen={isOpen}
        nextStage={nextStage}
        onClose={() => !isLoading && setIsOpen(false)}
        onConfirm={handleConfirm}
        primaryDisabled={isLoading}
        primaryLoading={isLoading}
        title="Submit Investigation Report"
        description="You are completing the actions assigned to you"
      />
    </>
  );
};